module.exports = __webpack_public_path__ + "img/Sample Image.3339f072.jpg";